import {ListWallets} from './list-wallets';

export default ListWallets;
